// extracted by css-extract-rspack-plugin
export default {"container":"AddIssueFieldButton-module__container__j5X4Bwu","button":"AddIssueFieldButton-module__button__n04q0ds"};